export const LEAD_OWNER_EMAIL = 'leadOwnerEmail';
